/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  initialDataLoading: false,
  isFetching: false,
  isSending: false,
  product: { id: 0 },
  products: []
};

const updateProduct = (products = [], newProduct = {}) =>
  products.map((product) => {
    if (product.id === newProduct.id) {
      return newProduct;
    }
    return product;
  });

const addWorkPackageToProduct = (
  products = [],
  productId = 0,
  workPackage = {}
) => {
  const newProduct = products.find((d) => d.id === productId);
  newProduct.results.push(workPackage);
  return products.map((d) => {
    if (d.id === newProduct.id) {
      return newProduct;
    }
    return d;
  });
};

const removeWorkPackageFromProduct = (
  products = [],
  productId = 0,
  workPackage = {}
) => {
  const newProduct = products.find((d) => d.id === productId);
  newProduct.results = newProduct.results.filter(
    (r) => r.id !== workPackage.id
  );
  return products.map((d) => {
    if (d.id === newProduct.id) {
      return newProduct;
    }
    return d;
  });
};

const productReducer = (state = initialState, action) => {
  const { team, productId, product, products, workPackage, type } = action;
  let updatedProducts;
  switch (type) {
    case Types.REQUEST_PRODUCT:
      return { ...state, isSending: true, isFetching: true };
    case Types.REQUEST_PRODUCT_FAILED:
      return { ...state, isSending: false, isFetching: false };
    case Types.RECEIVE_PRODUCTS:
      return {
        ...state,
        initialDataLoading: false,
        isFetching: false,
        isSending: false,
        products
      };
    case Types.ADD_PRODUCT:
      return {
        ...state,
        initialDataLoading: false,
        isFetching: false,
        isSending: false,
        products: [...state.products, product]
      };
    case Types.SET_PRODUCT:
      return {
        ...state,
        isFetching: false,
        isSending: false,
        noproduct: false,
        product
      };
    case Types.SEND_PRODUCT:
      return { ...state, isSending: true };
    case Types.ADD_WORK_PACKAGE_TO_PRODUCT:
      return {
        ...state,
        isSending: false,
        products: addWorkPackageToProduct(
          state.products,
          productId,
          workPackage
        )
      };
    case Types.REMOVE_WORK_PACKAGE_FROM_PRODUCT:
      return {
        ...state,
        isSending: false,
        products: removeWorkPackageFromProduct(
          state.products,
          productId,
          workPackage
        )
      };
    case Types.UPDATE_PRODUCT:
      return {
        ...state,
        isSending: false,
        isFetching: false,
        products: updateProduct(state.products, product)
      };
    case Types.UPDATE_PRODUCT_TEAMS:
      updatedProducts = state.products.map((prod) => {
        const newTeams = prod.teams.map((pt) => {
          if (pt.id === team.id) {
            delete team.products;
            return team;
          }
          return pt;
        });
        return { ...prod, teams: newTeams };
      });
      return { ...state, products: updatedProducts };
    case Types.DELETE_PRODUCT:
      updatedProducts = state.products.filter((p) => p.id !== productId);

      return { ...state, products: updatedProducts };
    case Types.CLEAR_ACTIVE_SPINNER:
      return { ...state, isFetching: false, isSending: false }
    default:
      return state;
  }
};

export default productReducer;
